import { DeleteButton, ViewButton } from "utils/Buttons";
import CommentModal from "./CommentModal";
import useActions from "./useActions";
import { useState } from "react";

const Actions = props => {

    const {
        accepted,
        comment,
        replies,
        user,
        lesson,
        fileId
    } = props;
    const [acceptedChanged, setAcceptedChanged] = useState(false);
    
    const {
        accept,
        deleteActions,
        editActions,
        modalComment,
        replyActions
    } = useActions(props);

    const closeModal = () => {
        modalComment.close();
        if (acceptedChanged) {
            props.onUpdate();
            setAcceptedChanged(false);
        }
    };

    const acceptComment = (variables, options = {}) => {
        accept.mutate(variables, {
            ...options,
            onSuccess: (...args) => {
                setAcceptedChanged(true);
                options?.onSuccess?.(...args);
            }
        });
    };

    const replyComment = (comment, options = {}) => {
        replyActions.mutate(comment, {
            ...options,
            onSuccess: (...args) => {
                setAcceptedChanged(true);
                options?.onSuccess?.(...args);
            }
        });
    };

    return (
        <td>
            <ViewButton
                title={"Ver comentário"}
                onClick={modalComment.open}
            />
            <CommentModal
                open={modalComment.state}
                onClose={closeModal}
                comment={comment}
                replies={replies}
                user={user}
                lesson={lesson}
                fileId={fileId}
                accepted={accepted}
                onAccept={acceptComment}
                onDelete={deleteActions.mutate}
                onEdit={editActions.mutate}
                editLoading={editActions.isLoading}
                onReply={replyComment}
                replyLoading={replyActions.isLoading}
            />
            <DeleteButton
                onClick={() => deleteActions.mutate()}
                isLoading={deleteActions.isLoading}
                title={"Deletar comentário"}
            />
        </td>
    );
}

export default Actions;
